import { useState } from 'react'
import { RadioGroup, Radio } from 'components/forms'
import HeartRating from 'components/heart-rating'
import { StarRating } from 'baby-design'
import { useFeature } from 'flagged'
import { InlineCounter } from '../../../product-filters/components/sections/filter-section'
import { Facet, OptionFacetValue } from './Types'

interface RatingFacetProps {
  facet: Facet<OptionFacetValue>
  onChange: (selectedOptions: { from: number; to: number }) => void
  initialValue?: { from: number; to: number }
}

export const RatingFacet = ({
  facet,
  onChange,
  initialValue,
}: RatingFacetProps) => {
  const [selectedOption, setSelectedOption] = useState<number>(
    initialValue?.from || 0
  )

  const showStarRating = useFeature('star_ratings_enabled')

  const handleChange = (selectedOption: number) => {
    const value = { from: selectedOption, to: 5 }
    setSelectedOption(selectedOption)
    onChange(value)
  }

  const handleShowAll = () => {
    onChange({ from: 0, to: 5 })
  }

  return (
    // @ts-ignore
    <RadioGroup>
      <Radio
        checked={selectedOption === 0}
        label={<span>Show All Ratings</span>}
        size="large"
        value={0}
        onChange={handleShowAll}
      />
      {(facet.values as OptionFacetValue[]).map(
        ({ label, count }: { label: string; count: number }, index) => {
          const rating = 5 - index
          const labelComponent = (
            <span>
              {label}{' '}
              {!showStarRating && (
                <HeartRating
                  className="inline mlm"
                  rating={rating}
                  reviewCount={0}
                />
              )}
              {showStarRating && (
                <StarRating
                  className="inline mlm"
                  rating={rating}
                  reviewCount={0}
                  showRating={false}
                />
              )}
              <InlineCounter count={count} />
            </span>
          )
          return (
            <Radio
              checked={selectedOption === rating}
              disabled={count === 0}
              key={label}
              label={labelComponent}
              size="large"
              value={label}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleChange(parseInt(e.target.value))
              }
            />
          )
        }
      )}
    </RadioGroup>
  )
}
